import Vue from "vue";
import App from "./App.vue";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
import "./styles/index.css";
import "@kouts/vue-modal/dist/vue-modal.css";
import store from "./store";
import router from "./router";
import i18n from "@/i18n";

Vue.config.productionTip = false;
Vue.use(LottieVuePlayer);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
